import type React from "react";
import { createContext, useContext, useState } from "react";

interface ViewerModeContextValue {
  forceViewerMode: boolean;
  setForceViewerMode: (value: boolean) => void;
}

const ViewerModeContext = createContext<ViewerModeContextValue>({
  forceViewerMode: false,
  setForceViewerMode: () => undefined,
});

// Superadmins can "switch to viewer mode" to preview the app as a non-admin.
// This is pure UI state, kept out of the profile (which holds only the user) so
// the profile can later be backed by TanStack Query without dragging UI state
// along. Defaults to false, so consumers work without a provider (e.g. tests).
export const ViewerModeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [forceViewerMode, setForceViewerMode] = useState(false);
  return (
    <ViewerModeContext.Provider value={{ forceViewerMode, setForceViewerMode }}>
      {children}
    </ViewerModeContext.Provider>
  );
};

export function useForceViewerMode(): boolean {
  return useContext(ViewerModeContext).forceViewerMode;
}

export function useSetForceViewerMode(): (value: boolean) => void {
  return useContext(ViewerModeContext).setForceViewerMode;
}
